export default __webpack_public_path__ + "static/como-funciona-076bd9486ae1ea4ac6b0817aeb9d83f3.jpg";